import React from "react";
import { useAuth } from "../../../contexts/authContext";

export const ActionCard = ({ onOpenModal }) => {
	const { currentUser } = useAuth();
	const handleOpenModal = () => {
		onOpenModal(true);
	};

	return (
		<div className="w-full p-4 text-center bg-white border border-gray-200 rounded-lg shadow-sm sm:p-8 dark:bg-gray-800 dark:border-gray-700">
			<h5 className="mb-2 text-3xl font-bold text-gray-900 dark:text-white">
				<span className="text-transparent bg-clip-text bg-gradient-to-r to-yellow-400 from-amber-600">{currentUser.displayName}</span>
				<span className="font-medium">, Start Building Your Music Catalog</span>
			</h5>
			<p className="mb-5 text-base text-gray-500 sm:text-lg dark:text-gray-400">
				Let's add the first song to your catalog. They can be ideas, <br />
				songs you're working on, or completed songs.
			</p>
			<div className="items-center justify-center space-y-4 sm:flex sm:space-y-0 sm:space-x-4 rtl:space-x-reverse">
				<button
					onClick={handleOpenModal}
					type="button"
					className="border text-yellow-400 hover:text-yellow-500 border-yellow-500 focus:outline-none focus:ring-2 focus:text-amber-700 focus:ring-amber-700 font-medium rounded-lg text-sm px-4 py-2 me-2 mb-2">
					Add Your First Song
				</button>
			</div>
		</div>
	);
};
